module.exports = __webpack_public_path__ + "img/tempo-bg-media.2aa2e2f4.png";